import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { Seo } from "../components/Seo";

const NotFound = () => {
  const { t, p } = useLang();
  return (
    <div className="bg-[#08090A] min-h-[80vh] flex items-center" data-testid="not-found-page">
      <Seo title={t.notFound.title} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-32 text-center w-full">
        <p className="font-mono text-[#FF6600] text-sm tracking-widest">404</p>
        <h1 className="mt-4 text-4xl sm:text-5xl font-black tracking-tight text-white">{t.notFound.title}</h1>
        <p className="mt-4 text-white/60">{t.notFound.text}</p>
        <Link to={p("")} data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center gap-2 bg-[#FF6600] hover:bg-[#FF9900] text-[#08090A] font-black rounded-full px-7 py-3.5 text-sm transition-colors">
          {t.notFound.cta}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
